import React, {ChangeEvent, DetailedHTMLProps, ReactNode, TextareaHTMLAttributes} from "react";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {get, Path, useFormContext} from "react-hook-form";

interface TextAreaProps<T extends FieldValues> extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
    register?: UseFormRegister<T>;
    registerOptions?: RegisterOptions;
    errors?: FieldErrors;
    name: Path<T>
    label?: string | ReactNode,

    totalChars?: number,
    addTextLength?: boolean
    textLength?: number,
}

export function TextAreaEx<T extends FieldValues>(props: TextAreaProps<T>) {
    const {errors, name, register, registerOptions, label, totalChars, textLength, addTextLength = false, ...rest} = props;
    //const message: string = errors ? (errors[name] ? errors[name]?.message : '') as string : '';
    const methods = useFormContext();
    const watchTextArea = methods ? (methods.watch(name)||'') : '';
    const textAreaLength = watchTextArea.length;
    if (!register)
        throw new Error('Non hai specificato <register>!');
    const newTotalChars = totalChars ? totalChars : 128
    // https://github.com/react-hook-form/react-hook-form/issues/735
    const error = get(errors, name);
    const {onChange: onChangeRegister, ...restRegister} = register(name, registerOptions);
    const onChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e: ChangeEvent<HTMLTextAreaElement>) => {
        onChangeRegister(e);
        //setLength(e.target.textLength);
    }
    return (
        <>
            <label htmlFor={name} className={`block text-sm font-medium mb-1 ${props.disabled ? 'opacity-50' : ''}`}>{label}</label>
            <textarea
                {...rest}
                {...restRegister} onChange={onChange}
                className={props.className ? props.className : `block w-full rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm
                                        ${errors && errors[name] ? 'border-rose-700' : 'border-gray-300'}
                                        disabled:opacity-50`
                }
            />
            {props.textLength !== undefined && <span className={`text-xs ${props.disabled ? 'opacity-50' : ''}`}>{props.textLength}&#47;{newTotalChars} caratteri</span>}

            {props.addTextLength && methods === null && <span className="text-danger">You need to wrap your form with the FormProvider component for useFormContext to work properly.</span>}
            {props.addTextLength && methods !== null && <span className={`text-xs ${props.disabled ? 'opacity-50' : ''}`}>{textAreaLength}&#47;{newTotalChars} caratteri</span>}
            {/*{errors && errors[name] && <p className="text-rose-700">{message}</p>}*/}
            {error && <p className="text-danger">{error.message}</p>}
        </>
    );
}

export default TextAreaEx;